
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './IconAndText.css';
import { Icon } from '../../importCL';

interface IIcon {
    iconPath: string;
    iconAltText: string;
    iconDescription: string;
}

interface IIconAndTextProps extends MappedComponentProperties {
    icons?: IIcon[];
}

export const IconAndTextEditConfig = {
    emptyLabel: 'IconAndText',
    isEmpty: (props: PropsWithChildren<IIconAndTextProps>) => {
        return !props || !props.icons || !props.icons.length;
    },
};

const IconAndText = (props: PropsWithChildren<IIconAndTextProps>): JSX.Element => {
    const isMultipleIcons = (props.icons && props.icons.length > 1);
    return (
        <div id='icon-and-text' className='IconAndText'>
            {props.icons?.map((icon:IIcon, index: number) => {
                return (
                    <div key={index} className={`IconAndText__container ${isMultipleIcons ? 'md:mt-0 md:mb-5' : ''} flex items-center pl-4 my-5 mx-0 pr-[4.6875rem] md:pr-0`}>
                        <Icon className='inline-block mr-4' size='badge' src={icon.iconPath} alt={icon.iconAltText} loading='lazy' />
                        {icon.iconDescription && <p>{transformHTMLParserLinks(icon.iconDescription)}</p>}
                    </div>
                );
            })}
        </div>
    );
};

export default IconAndText;
